import { supabase } from "./supabase";
import { applyAuthState } from "./homepage-cta-lib";

// The header of the content pages (FAQ, legal; #621): "Sign in", or
// "Open app" with a session, like the homepage nav.
void supabase.auth.getSession().then(({ data }) => {
  if (!data.session) return;
  applyAuthState(document, true);
});
